import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import '../../../styleLess/signature/Taskdetail.scss'
import ModalUpdate from 'common/KPIFinance/modalUpdate'
import { InboxOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
import { Button } from 'antd'
import { useParams } from 'react-router-dom'
import FormatMoney from 'common/FormatNumber/money'
import FormatMinMax from 'common/FormatNumber/minmax'
import loadingAnimationSvg from 'icons/three-dots.svg'
import { CounterContext } from 'redux/Golbalvalues'
const Container = styled.div``
const EmptyStateContainer = styled.div``
const ContainerCard = styled.div``
const Card = styled.div``
const Upper = styled.div``
const Lower = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}

const KPIfinanceTask = (props) => {
  const {
    hidden,
    getLogList,
    dataKPIFinance,
    getResultKpi,
    loadingBtnDone,
    taskLevel,
  } = props
  // console.log(taskLevel)
  const [visableModalTaskGoals, setVisableModalTaskGoals] = useState(false)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [data, setData] = useState(initalState.data)
  const [precision, setPrecision] = useState(12)
  const { project_id, subtaskId } = useParams()
  const token = getCookie('access_token_admin')
  const { mainRoleUser, adminPermission } = useContext(CounterContext)
  // console.log(dataKPIFinance)
  const showModal = () => {
    return (
      <div>
        <ModalUpdate
          precision={precision}
          setPrecision={setPrecision}
          setVisableModalTaskGoals={setVisableModalTaskGoals}
          visableModalTaskGoals={visableModalTaskGoals}
          getResultKpi={getResultKpi}
          data={data}
          subtaskId={subtaskId}
          getLogList={getLogList}
          taskLevel={taskLevel}
        />
      </div>
    )
  }
  const handleClick = (item) => {
    setPrecision(12)
    setVisableModalTaskGoals(true)
    setData(item)
  }
  const showActualGoal = (data) => {
    const isSection = data.section
    // console.log(isSection)
    // console.log('item name is ', data.name, ':', data)
    if (data.input_type_id === 22) {
      // min max
      let onlyMin = data?.sprintflow_min
      let onlyMax = data?.sprintflow_max
      if ((isSection === 'of task' || isSection === 'of subtask') && taskLevel === 1) {
        onlyMin = data?.min
        onlyMax = data?.max
      }
      // const onlyMin = ['of task', 'of subtask'].includes(isSection)
      //   ? data?.min
      //   : data?.sprintflow_min
      // const onlyMax = ['of task', 'of subtask'].includes(isSection)
      //   ? data?.max
      //   : data?.sprintflow_max

      return (
        <div>
          <span className="small">Current Value / Goal</span>
          <div style={{ display: 'grid' }}>
            <p className="cutter-text-min-max">
              <FormatMinMax num={data.actual_goal} /> /{' '}
              {/* <FormatMinMax num={data.sprintflow_min} /> {data.unit_type_name} -{' '}
              <FormatMinMax num={data.sprintflow_max} /> {data.unit_type_name} */}
              <FormatMinMax num={onlyMin} />
              {data.unit_type_name} -{' '}
              <FormatMinMax num={onlyMax} /> {data.unit_type_name}
            </p>
          </div>
        </div>
      )
    } else {
      //goal
      let onlyGoal = data?.sprintflow_goal
      if ((isSection === 'of task' || isSection === 'of subtask') && taskLevel === 1) {
        onlyGoal = data?.goal
      }
      // const onlyGoal = ['of task', 'of subtask'].includes(isSection)
      //   ? data?.goal
      //   : data?.sprintflow_goal
      return (
        <div>
          <span className="small">Current Value / Goal</span>
          <div style={{ display: 'grid' }}>
            <p className="cutter-text-min-max">
              <FormatMoney num={data.actual_goal} /> /{' '}
              {/* <FormatMoney num={data.sprintflow_goal} /> {data.unit_type_name} */}
              <FormatMoney num={onlyGoal} /> {data.unit_type_name}
            </p>
          </div>
        </div>
      )
    }
  }
  const loadingPage = () => {
    return (
      <div className="loading-task-detail">
        <img src={loadingAnimationSvg}></img>
      </div>
    )
  }
  const showContent = () => {
    if (dataKPIFinance.length > 0) {
      return (
        <Container className="container-kpi">
          {loadingBtnDone ? (
            loadingPage()
          ) : (
            <ContainerCard className="container-card">
              {dataKPIFinance &&
                dataKPIFinance.map((item) => {
                  return (
                    <Card className="card">
                      <div>
                        <span className="small">KPI/Finance</span>
                        <div style={{ display: 'grid' }}>
                          <p className="cutter-text-line-1">{item.name}</p>
                        </div>
                      </div>
                      {showActualGoal(item)}
                      <Lower className="lower">
                        <div className="row3">
                          <span className="small">KPI Type</span>
                          <div style={{ display: 'grid' }}>
                            <p className="cutter-text-line-1">{item.kpi_type_name_en}</p>
                          </div>
                        </div>
                        <div>
                          <Button
                            id="btn_updateKPI"
                            className='BTN_Next'
                            onClick={() => handleClick(item)}
                            hidden={hidden}
                          >
                            Update
                          </Button>
                        </div>
                      </Lower>
                    </Card>
                  )
                })}
            </ContainerCard>
          )}
        </Container>
      )
    } else {
      return (
        <>
          {loadingBtnDone ? (
            <Container className="container-kpi">{loadingPage()}</Container>
          ) : (
            <EmptyStateContainer className="EmptyStateContainer">
              <InboxOutlined className="InboxOutlined big-icons" />
              <h2>Please update your KPI/Finance</h2>
            </EmptyStateContainer>
          )}
        </>
      )
    }
  }
  return (
    <Container>
      {showContent()}
      {showModal()}
    </Container>
  )
}

export default KPIfinanceTask
